import React from 'react';
import Alert from 'react-bootstrap/Alert';

export const ErrorAlert: React.FC<{ errorMessage: string }> = (props) => {
    return <Alert variant="warning">{props.errorMessage}</Alert>
}